import dayjs from "dayjs";
import { map } from "lodash";
import { Button, Space, Table } from "antd";
import { ColumnType } from "antd/es/table";
import useModal from "antd/es/modal/useModal";

import { usePagination } from "../../hooks/usePagintation";
import { BidForm } from "./BidForm";
import { useBids, useUpdateBid } from "../../hooks/apis/bids";
import numeral from "numeral";
import { useForm } from "antd/es/form/Form";

type BidListProps = {
  cars: Array<{
    bookingTimes: number[];
    id: number;
    title: string;
    imageUrl: { isCover: boolean; url: string }[];
    brand: { id: number; name: string };
    modal: string;
    price: number;
    type: string;
    years: number;
    coordinatorName?: string;
    createdAt: number;
    location?: string;
    merchantId: number;
    name: string;
    phone: string;
    salerId?: string;
    status: "PENDING" | "CONCATED" | "DONE";
    viewingType: "ONLINE" | "OFFLINE";

    color: string;
    kilometers: number;
    basePrice: number;
    customerName: string;
    customerEmail: string;
    customerPhone: string;

    markTravelLicenseImageUrl: string;
    markAppraisalImageUrl?: string;
  }>;
};

export function BidList() {
  const pagination = usePagination({
    defaultPageSize: 30,
  });

  const { data: { cars = [], total } = {}, isLoading: isAuditsLoading } = useBids({
    take: pagination.take,
    skip: pagination.skip,
    reviewStatus: "ACTIVATED",
  });
  const { mutateAsync: updateBidDetail, isLoading: isUpdateBidDetailLoading } = useUpdateBid();

  const [modal, contextHolder] = useModal();

  const [form] = useForm();

  const onEditButtonClick = async (car: BidListProps["cars"][number]) => {
    const m = modal.confirm({
      width: 800,
      cancelText: "關閉",
      content: (
        <BidForm
          form={form}
          car={{
            ...car,
            brand: car.brand.name,
            imageUrl: map(car.imageUrl || [], (item, index: number) => ({ ...item, id: index + 1 })) || [],
            bookingTimes: map(car.bookingTimes, item => dayjs(item)),
          }}
        />
      ),
      icon: null,
      okText: "我要競標",
      okButtonProps: { danger: true },
      title: "商品",
      onOk: async () => {
        const values = await form.validateFields();
        updateBidDetail({ customerCarId: car.id, price: Number(values.price) });
        m.destroy();
      },
    });
  };

  const columns: ColumnType<BidListProps["cars"][number]>[] = [
    { align: "center", dataIndex: "id", title: "ID", width: 50 },
    {
      dataIndex: "title",
      title: "商品名稱",
      width: 200,
    },
    {
      dataIndex: ["brand", "name"],
      title: "車廠",
      width: 120,
    },
    {
      dataIndex: "type",
      title: "車款",
      width: 120,
    },
    // {
    //   dataIndex: "modal",
    //   title: "車種",
    //   width: 120,
    // },
    {
      dataIndex: "color",
      title: "車色",
      width: 80,
    },
    {
      dataIndex: "kilometers",
      title: "里程",
      render: (kilometers: number) => numeral(kilometers).format("0,0"),
    },
    {
      dataIndex: "basePrice",
      title: "底價",
      render: (basePrice: number) => numeral(basePrice).format("$0,0"),
    },
    {
      dataIndex: "years",
      title: "出廠年份",
    },
    {
      title: "操作",
      width: 50,
      render: car => {
        return (
          <Button onClick={() => onEditButtonClick(car)} size="small" type="default">
            詳情
          </Button>
        );
      },
    },
  ];

  return (
    <Space direction="vertical" className="w-full">
      <div className="text-2xl font-bold">競標管理</div>

      {contextHolder}

      <Table
        dataSource={cars || []}
        columns={columns}
        loading={isAuditsLoading || isUpdateBidDetailLoading}
        pagination={{ ...pagination, total }}
        scroll={{ x: "max-content" }}
        size="small"
        rowKey="id"
      ></Table>
    </Space>
  );
}
